export default "__VITE_ASSET__BG1rLi6C__"